// HomePageRows.jsx
import React,{ useMemo } from "react";
import {
    useGetHomeRowsClientQuery,
} from "../../services/modules/homeRows/index";

import TopFiveSlider from "../TopFiveSlider/TopFiveSlider.js";
import VideoRow from "../VideoRow/VideoRow.js";
import VideoRowNumber from "../VideoRowNumber/VideoRowNumber.js";
import VideoRowPlaylist from "../VideoRowPlaylist/VideoRowPlaylist.js";
import VideoItemHorizontal from "../VideoItemHorizontal/VideoItemHorizontal.js";

const HomePageRows = () => {
    const {
        data,
        isLoading,
        isFetching,
        refetch,
    } = useGetHomeRowsClientQuery(undefined, {
        // refetchOnMountOrArgChange: true,
        // refetchOnFocus: true,
        // refetchOnReconnect: true,
    });

    // compat: rows può essere data.rows o data.data.rows
    const rows = useMemo(
        () => (data?.rows || data?.data?.rows || []).filter(r => r.isActive),
        [data]
    );

    if (isLoading || isFetching) return <div className="p-4">Caricamento…</div>;
    if (!rows.length) return <div className="p-4 text-gray-500">Nessuna riga disponibile.</div>;

    return (
        <div className="space-y-8">
            {rows.map((row) => (
                <RowRenderer key={row.id} row={row} />
            ))}
        </div>
    );
};

export default HomePageRows;

const RowRenderer = ({ row }) => {
    let title = row.title || "";
    let coverImage = row.coverImage || null;
    let categoryId = null;
    let playlistCategoryId = null;

    if (row.type === "CATEGORY") {
        title = row.category?.name || row.title || "Categoria";
        coverImage = row.category?.coverImage || row.coverImage || null;
        categoryId = row.categoryId;
        if (!categoryId) return null; 
    }

    if (row.type === "PLAYLISTCATEGORY") {
        title = row.playlistCategory?.name || row.title || "Playlist";
        coverImage = row.playlistCategory?.coverImage || row.coverImage || null;
        playlistCategoryId = row.playlistCategoryId;
        if (!playlistCategoryId) return null; 
    }

    switch (row.type) {
        case "TOP5":
            return <TopFiveSlider />;

        case "RECOMMENDED":
            return <VideoRowNumber title="Consigliati" api="/user/recommended" />;

        case "CONTINUA_GUARDARE":
            return <VideoRow title="Continua a guardare" api="/views/unfinished" />;
        case "ULTIMI_VIDEO":
            return <VideoRow title="Ultimi Video" api="/user/getlatestvideosbynetwork" />;
        case "CATEGORY":
            return (
                <VideoItemHorizontal
                    key={row.id}
                    title={title}
                    coverImage={coverImage}
                    categoryId={categoryId}
                />
            );

        case "PLAYLISTCATEGORY":
            return (
                <VideoRowPlaylist
                    key={row.id}
                    title={title}
                    coverImage={coverImage}
                    categoryId={playlistCategoryId}
                />
            );

        default:
            return null;
    }
};


const TopFiveSection = () => (
    <section>
        <TopFiveSlider />
    </section>
);

const RecommendedSection = () => (
    <section>
        <VideoRowNumber title="Consigliati" api="/user/recommended" />
    </section>
);

const ContinueWatchingSection = () => (
    <section>
        {/* Cambia l’endpoint se ne usi un altro */}
        <VideoRow title="Continua a guardare" api="/user/continue-watching" />
    </section>
);

const CategorySection = ({ row }) => {
    const title = row.title || "Categoria";
    const api = `/user/videos-by-category?categoryId=${row.categoryId}`;

    return (
        <section>
            <h3 className="text-lg font-semibold mb-3">{title}</h3>
            <VideoItemHorizontal api={api} />
        </section>
    );
};

const PlaylistCategorySection = ({ row }) => {
    const title = row.title || "Playlist";
    const api = `/user/playlists-by-category?playlistCategoryId=${row.playlistCategoryId}`;

    return (
        <section>
            <VideoRowPlaylist title={title} api={api} />
        </section>
    );
};
